// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"7456":"81f6867a3249e31e","7793":"bf3a934dfeba9e60"}[chunkId] + ".css";
};